import { FC } from 'react';
import { useScenariosPageQuery } from '../../services';
import { IressStack } from '@iress-oss/ids-components';
import { CreateScenario } from './CreateScenario/CreateScenario';
import { ScenariosTable } from './ScenarioTable/ScenariosTable';
import { Section } from '../Section/Section';
import { usePageSearchParams } from '../../hooks';
import { ScenariosPage } from '@xplan-pension-switching/common';

export const ScenarioFormContent: FC = () => {
    const { entityId } = usePageSearchParams();
    const { data } = useScenariosPageQuery(entityId);
    const { cases, scenarios, clients } = (data as { scenariosPage: ScenariosPage }).scenariosPage;

    return (
        <IressStack gutter={'md'}>
            <Section heading={'Create a scenario'}>
                <CreateScenario cases={cases} clients={clients} />
            </Section>
            <Section heading={'Existing scenarios'}>
                <ScenariosTable scenarios={scenarios} />
            </Section>
        </IressStack>
    );
};
